<template>
  <div class="container">
    <div class="titleBox">
      <div class="left">
        <div class="starIcon">
          <img src="@/assets/homepage/productCase/xingxing.png">
        </div>
        <div class="title">{{ info.theme }}</div>
      </div>
      <div class="right">
        <img class="leftArrow" :src="leftArrow" @click="leftScorll">
        <img class="rightArrow" :src="rightArrow" @click="rightScorll">
      </div>
    </div>
    <div class="inforBox">
      <IScrollView ref="IScrollView" @changeArrow="changeArrow">
        <div class="scroll-content">
          <div class="itemBox">
            <div class="scroll-item" v-for="(item,index) in info.infos" :key="index">
              <img class="scorllImg" :src="item.img">
              <div class="line"></div>
              <div class="scorllTitile">{{ item.title }}</div>
              <div>
                <div v-if="!(item.desc instanceof Array)" class="scorllDesc">{{ item.desc }}</div>
                <div v-else class="scorllDesc">
                  <ul>
                    <li v-for="(el,index) in item.desc" :key="index">{{ el }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </IScrollView>
    </div>
  </div>
</template>
<script>

import IScrollView from "@/components/content/iScrollView/IScrollView.vue";

export default {
  name: 'HightlightsScorllView',
  components: {IScrollView},
  props: {
    info: {
      type: Object, default() {
        return {}
      }
    }
  },
  data() {
    return {
      grayArrowLeft: require('@/assets/homepage/productCase/arrow_left@2x.png'),
      blueArrowLeft: require('@/assets/homepage/productCase/arrow_right@2x.png'),
      blueArrowRight: require('@/assets/homepage/productCase/arrow_right@2x(1).png'),
      grayArrowRight: require('@/assets/homepage/productCase/arrow_left@2x(1).png'),
      leftArrow: require('@/assets/homepage/productCase/arrow_left@2x.png'),
      rightArrow: require('@/assets/homepage/productCase/arrow_right@2x(1).png')
    }
  },
  mounted() {
  },

  methods: {
    changeArrow(flag) {
      if (flag === 0) {
        this.rightArrow = this.blueArrowRight
        this.leftArrow = this.grayArrowLeft
      } else if (flag === 1) {
        this.rightArrow = this.grayArrowRight
        this.leftArrow = this.blueArrowLeft
      } else {
        this.rightArrow = this.blueArrowRight
        this.leftArrow = this.blueArrowLeft
      }
    },
    rightScorll() {
      this.$refs['IScrollView'].rightScorllFn()
    },
    leftScorll() {
      this.$refs['IScrollView'].leftScorllFn()
    }
  }
}
</script>
<style lang="scss" scoped>

html, body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  // 解决IScroll拖拽卡顿问题
  touch-action: none;
}

.container {
  width: 1375px;
  //height: 844px;
  background: #FFFFFF;
  border-radius: 24px;
  box-sizing: border-box;
  padding-bottom: 50px;

  .titleBox {
    display: flex;
    justify-content: space-between;

    .left {
      margin-top: 61px;
      margin-left: 79px;
      display: flex;
      height: 56px;
      line-height: 56px;

      .starIcon {
        border-radius: 50%;
        background-color: #E8EEFC;
        width: 56px;
        justify-content: center;
        display: flex;
        align-items: center;

        img {
          width: 40px;
          height: 38px;
        }
      }

      .title {
        padding: 0;
        margin-left: 24px;
        font-size: 56px;
        font-family: "SourceHanSansSC-Heavy-2";
        font-weight: 800;
        color: #2A45A7;
      }
    }

    .right {
      margin-top: 54px;
      margin-right: 98px;

      img {
        width: 70px;
        height: 70px;
      }

      .leftArrow {
        margin-right: 40px;
      }

      .rightArrow {
        background-color: white;
      }
    }
  }

  .inforBox {
    margin: 0 79px;
    margin-top: 80px !important;

    .scroll-content {
      box-sizing: border-box;
      display: inline-block;

      .itemBox {
        display: flex;

        .scroll-item {
          margin-right: 120px;
          width: 400px;

          .scorllImg {
            width: 100%;
            height: 279px;
            border-radius: 16px;
          }

          .line {
            margin-top: 47px;
            margin-bottom: 24px;
            width: 400px;
            height: 0px;
            opacity: 1;
            border: 4px solid #2A45A7;
          }

          .scorllTitile {
            white-space: break-spaces;
            text-align: left;
            font-size: 32px;
            font-family: "SourceHanSansSC-Heavy-2";
            font-weight: 800;
            color: #2A45A7;
            margin-bottom: 25px;
          }

          .scorllDesc {
            white-space: break-spaces;
            width: 421px;
            text-align: left;
            font-size: 24px;
            font-family: "SourceHanSansSC-Medium-2";
            font-weight: 500;
            color: #24262B;

            ul {
              width: 401px;
              padding-left: 20px;

              li {
                list-style-type: disc;
              }

              li::marker {
                color: #24262B;
                font-size: 14px;
              }
            }
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/homepage/childComps/HighlightsScrollView.vue